import { rest } from 'msw'

export default [
  /**
   * テクニカルレポート
   */
  rest.get('/swc-api/nodes/:nodeId/ro/technical-report/results/', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json(
        {
          "node_id":10003,
          "node_name":"10003",
          "calculation_result_list":[
             {
                "calculation_no":1,
                "calculation_name":"1\u7cfb\u7d71",
                "total_result":1,
                "group_results":[
                   {
                      "group_code":"cf_diff_pressure",
                      "group_name":"CF\u5dee\u5727",
                      "result":0,
                      "items":[
                         "cf_in_pressure",
                         "cf_out_pressure",
                         "cf_diff_pressure"
                      ],
                      "item_names":[
                         "CF\u5165\u53e3\u5727\u529b",
                         "CF\u51fa\u53e3\u5727\u529b",
                         "CF\u5dee\u5727"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               0.360341085271318,
                               0.360452934662237,
                               0.00024031007751938
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               0.356714757709251,
                               0.356494493392071,
                               0.00038215859030837
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               0.348767676767677,
                               0.348070707070707,
                               0.00078675645342312
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               0.344837799717913,
                               0.344087447108604,
                               0.000867418899858956
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               0.34162641509434,
                               0.340890566037736,
                               0.0009
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               0.339239106145251,
                               0.338848044692737,
                               0.000553072625698324
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               0.339404,
                               0.338752,
                               0.000752
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               0.343241610738255,
                               0.342492617449664,
                               0.000851006711409396
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               0.36050976744186,
                               0.360498604651163,
                               0.000286511627906977
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               0.357492409867173,
                               0.35727229601518,
                               0.000409867172675522
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               0.339213785046729,
                               0.338496495327103,
                               0.000810747663551402
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               0.354842459173871,
                               0.354490874159462,
                               0.000534101825168108
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               0.358032934131737,
                               0.35812375249501,
                               0.000207584830339321
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               0.346719191919192,
                               0.346341414141414,
                               0.000493939393939394
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               0.35339009009009,
                               0.353327027027027,
                               0.000240540540540541
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               0.349075850043592,
                               0.349072362685266,
                               0.000245858761987794
                            ],
                            "results":[
                               0,
                               0,
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"pressure",
                      "group_name":"\u5727\u529b",
                      "result":0,
                      "items":[
                         "ro_in_pressure",
                         "ro_1st_out_pressure",
                         "ro_2nd_out_pressure",
                         "ro_permeated_water_pressure"
                      ],
                      "item_names":[
                         "RO\u5165\u53e3\u5727\u529b",
                         "RO1st\u51fa\u53e3\u5727\u529b",
                         "RO2nd\u51fa\u53e3\u5727\u529b",
                         "RO\u900f\u904e\u6c34\u5727\u529b"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               1.25810631229236,
                               1.16010631229236,
                               1.05724916943522,
                               0.0339291251384275
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               1.32770374449339,
                               1.22849339207048,
                               1.12947907488987,
                               0.0339218061674009
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               1.44631200897868,
                               1.34626487093154,
                               1.25456341189675,
                               0.0341189674523008
                            ],
                            "results":[
                               1,
                               1,
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               1.50585895627645,
                               1.40492806770099,
                               1.31583779971791,
                               0.0342186177715092
                            ],
                            "results":[
                               1,
                               1,
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               1.56056037735849,
                               1.45980377358491,
                               1.37617169811321,
                               0.0343905660377359
                            ],
                            "results":[
                               1,
                               1,
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               1.56572849162011,
                               1.46417653631285,
                               1.38033854748603,
                               0.0344368715083799
                            ],
                            "results":[
                               1,
                               1,
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               1.56377066666667,
                               1.46189333333333,
                               1.37833466666667,
                               0.034072
                            ],
                            "results":[
                               1,
                               1,
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               1.51098926174497,
                               1.40895838926174,
                               1.32138657718121,
                               0.0338778523489933
                            ],
                            "results":[
                               1,
                               1,
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               1.25546604651163,
                               1.15643441860465,
                               1.05342325581395,
                               0.0338037209302326
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               1.29470113851992,
                               1.195055028463,
                               1.09431499051233,
                               0.0337001897533207
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               1.54942406542056,
                               1.44663317757009,
                               1.36351285046729,
                               0.0337242990654206
                            ],
                            "results":[
                               1,
                               1,
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               1.29761479346782,
                               1.19801633045149,
                               1.10025360230548,
                               0.034030739673391
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               1.21854790419162,
                               1.11961177644711,
                               1.01820858283433,
                               0.0339770459081837
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               1.35279797979798,
                               1.25266363636364,
                               1.16239090909091,
                               0.0342010101010101
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               1.23500630630631,
                               1.13708828828829,
                               1.04131531531532,
                               0.0345018018018018
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               1.28644551002616,
                               1.18749084568439,
                               1.09623278116827,
                               0.0340340017436792
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"pressure_loss",
                      "group_name":"\u5727\u529b\u640d\u5931",
                      "result":1,
                      "items":[
                         "all_pressure_loss",
                         "ro_1st_pressure_loss",
                         "ro_2nd_pressure_loss"
                      ],
                      "item_names":[
                         "\u5168\u4f53\u5727\u529b\u640d\u5931",
                         "RO1st\u5727\u529b\u640d\u5931",
                         "RO2nd\u5727\u529b\u640d\u5931"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               0.200847176079734,
                               0.0980265780730897,
                               0.102820598006645
                            ],
                            "results":[
                               1,
                               0,
                               2
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               0.198226872246696,
                               0.0992103524229075,
                               0.0990165198237886
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               0.191763187429854,
                               0.100054994388328,
                               0.0917081930415264
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               0.190014104372355,
                               0.100932299012694,
                               0.0890818053596615
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               0.18437358490566,
                               0.100756603773585,
                               0.0836169811320755
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               0.185395530726257,
                               0.101551955307263,
                               0.0838435754189944
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               0.185437333333333,
                               0.101874666666667,
                               0.0835626666666667
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               0.189610738255034,
                               0.102036241610738,
                               0.0875744966442953
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               0.202040930232558,
                               0.0990260465116279,
                               0.10301488372093
                            ],
                            "results":[
                               1,
                               0,
                               2
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               0.200411764705882,
                               0.0996489563567362,
                               0.100762808349146
                            ],
                            "results":[
                               1,
                               0,
                               2
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               0.18592523364486,
                               0.102797897196262,
                               0.0831273364485981
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               0.197380403458213,
                               0.0996003842459174,
                               0.0977800192122959
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               0.200341317365269,
                               0.0989341317365269,
                               0.101407185628743
                            ],
                            "results":[
                               1,
                               0,
                               2
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               0.190407070707071,
                               0.100140404040404,
                               0.0902666666666667
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               0.193688288288288,
                               0.0979153153153153,
                               0.095772972972973
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               0.190216216216216,
                               0.0989625108979948,
                               0.0912537053182214
                            ],
                            "results":[
                               0,
                               0,
                               1
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"water_flow",
                      "group_name":"\u6d41\u91cf",
                      "result":1,
                      "items":[
                         "permeated_water_flow",
                         "concentrated_water_flow"
                      ],
                      "item_names":[
                         "\u900f\u904e\u6c34\u6d41\u91cf",
                         "\u6fc3\u7e2e\u6c34\u6d41\u91cf"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               37.093023255814,
                               15.8112956810631
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               38.8732378854626,
                               15.0649779735683
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               42.7994388327722,
                               13.4941638608305
                            ],
                            "results":[
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               44.64682651622,
                               12.7433004231312
                            ],
                            "results":[
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               46.8681132075472,
                               11.6328301886792
                            ],
                            "results":[
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               47.2150837988827,
                               11.7544134078212
                            ],
                            "results":[
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               47.1609333333333,
                               11.7285333333333
                            ],
                            "results":[
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               45.2173154362416,
                               12.5767785234899
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               37.030511627907,
                               15.7913488372093
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               38.3407969639469,
                               15.2935483870968
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               47.2136682242991,
                               11.7589953271028
                            ],
                            "results":[
                               0,
                               1
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               39.4878962536023,
                               14.9162343900096
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               37.2685628742515,
                               15.939620758483
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               42.6745454545455,
                               13.6730303030303
                            ],
                            "results":[
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               39.4053153153153,
                               14.9737837837838
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               41.5205754141238,
                               14.1487358326068
                            ],
                            "results":[
                               1,
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"conductivity",
                      "group_name":"\u5c0e\u96fb\u7387",
                      "result":0,
                      "items":[
                         "conductivity"
                      ],
                      "item_names":[
                         "\u5c0e\u96fb\u7387"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               2.66031007751938
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               2.30939427312775
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               2.29780022446689
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               2.31637517630465
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               2.4587358490566
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               2.50218994413408
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               2.61686666666667
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               2.7175033557047
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               2.54279069767442
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               2.46323529411765
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               2.3285046728972
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               2.49403458213256
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               2.5448502994012
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               2.70725252525253
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               2.68934234234234
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               2.67139494333043
                            ],
                            "results":[
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"water_temperature",
                      "group_name":"\u6c34\u6e29",
                      "result":0,
                      "items":[
                         "water_temperature"
                      ],
                      "item_names":[
                         "\u6c34\u6e29"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               7.75016611295681
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               7.59867841409692
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               7.75622895622896
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               7.76107193229901
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               8.01396226415094
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               8.10458100558659
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               8.1424
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               8.02697986577181
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               7.94688372093023
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               8.0157495256167
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               8.45385514018692
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               8.66666666666667
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               8.85289421157685
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               9.38505050505051
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               9.83126126126126
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               10.0430688753269
                            ],
                            "results":[
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"corrected_permeated_water_flow",
                      "group_name":"\u88dc\u6b63\u900f\u904e\u6c34\u91cf",
                      "result":0,
                      "items":[
                         "corrected_permeated_water_flow"
                      ],
                      "item_names":[
                         "\u88dc\u6b63\u900f\u904e\u6c34\u91cf\uff08FLUX\uff09"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               7.75016611295681
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               7.59867841409692
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               7.75622895622896
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               7.76107193229901
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               8.01396226415094
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               8.10458100558659
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               8.1424
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               8.02697986577181
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               7.94688372093023
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               8.0157495256167
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               8.45385514018692
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               8.66666666666667
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               8.85289421157685
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               9.38505050505051
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               9.83126126126126
                            ],
                            "results":[
                               1
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               10.0430688753269
                            ],
                            "results":[
                               0
                            ]
                         }
                      ]
                   }
                ]
             },
             {
                "calculation_no":2,
                "calculation_name":"2\u7cfb\u7d71",
                "total_result":2,
                "group_results":[
                   {
                      "group_code":"pressure",
                      "group_name":"\u5727\u529b",
                      "result":0,
                      "items":[
                         "ro_in_pressure",
                         "ro_1st_out_pressure",
                         "ro_2nd_out_pressure",
                         "ro_3rd_out_pressure",
                         "ro_permeated_water_pressure"
                      ],
                      "item_names":[
                         "RO\u5165\u53e3\u5727\u529b",
                         "RO1st\u51fa\u53e3\u5727\u529b",
                         "RO2nd\u51fa\u53e3\u5727\u529b",
                         "RO3rd\u51fa\u53e3\u5727\u529b",
                         "RO\u900f\u904e\u6c34\u5727\u529b"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               0.860028335301062,
                               0.764250295159386,
                               0.689038961038961,
                               0.627976387249114,
                               0.0549043683589138
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               0.901398364485981,
                               0.799886682242991,
                               0.720702102803738,
                               0.657828271028037,
                               0.054213785046729
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               0.985085549132948,
                               0.871630057803468,
                               0.785454335260116,
                               0.71974450867052,
                               0.0563491329479769
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               1.03966772655008,
                               0.918545310015898,
                               0.826683624801272,
                               0.759712241653418,
                               0.0570143084260731
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               1.0721130952381,
                               0.945704365079365,
                               0.850865079365079,
                               0.782416666666667,
                               0.0570119047619048
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               1.07076069364162,
                               0.944435838150289,
                               0.849936416184971,
                               0.781382658959538,
                               0.0579156069364162
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               1.06911325966851,
                               0.943064917127072,
                               0.848361878453039,
                               0.779458563535912,
                               0.0573024861878453
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               1.02942185338866,
                               0.908976486860304,
                               0.818056708160443,
                               0.751004149377593,
                               0.0556652835408022
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               0.852502517623363,
                               0.757020140986908,
                               0.681675730110775,
                               0.620768378650554,
                               0.0532124874118832
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               0.880639121338912,
                               0.781509414225941,
                               0.703223849372385,
                               0.641452928870293,
                               0.0552907949790795
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               1.05617569193742,
                               0.930510228640193,
                               0.837058965102286,
                               0.768571600481348,
                               0.0577605294825512
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               0.887791077257889,
                               0.786115342763874,
                               0.70693471164309,
                               0.644989118607182,
                               0.0553677910772579
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               0.827317919075145,
                               0.733890173410405,
                               0.660428901734104,
                               0.600884393063584,
                               0.0555028901734104
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               0.929935414424112,
                               0.82,
                               0.737016146393972,
                               0.673786867599569,
                               0.0562357373519914
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               0.846506196377502,
                               0.747826501429933,
                               0.671888465204957,
                               0.611568160152526,
                               0.0554852240228789
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               0.89455704008222,
                               0.787528263103803,
                               0.707223021582734,
                               0.644838643371017,
                               0.0555642343268243
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0,
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"pressure_loss",
                      "group_name":"\u5727\u529b\u640d\u5931",
                      "result":0,
                      "items":[
                         "all_pressure_loss",
                         "ro_1st_pressure_loss",
                         "ro_2nd_pressure_loss",
                         "ro_3rd_pressure_loss"
                      ],
                      "item_names":[
                         "\u5168\u4f53\u5727\u529b\u640d\u5931",
                         "RO1st\u5727\u529b\u640d\u5931",
                         "RO2nd\u5727\u529b\u640d\u5931",
                         "RO3rd\u5727\u529b\u640d\u5931"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               0.232042502951594,
                               0.0957768595041322,
                               0.0752172373081464,
                               0.0610484061393152
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               0.243559579439252,
                               0.101509345794393,
                               0.0791775700934579,
                               0.0628726635514019
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               0.265323699421965,
                               0.113438150289017,
                               0.08618612716763,
                               0.0656994219653179
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               0.279960254372019,
                               0.121135135135135,
                               0.0918537360890302,
                               0.0669713831478537
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               0.289662698412698,
                               0.126394841269841,
                               0.0948412698412698,
                               0.0684265873015873
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               0.28937225433526,
                               0.126332947976879,
                               0.0944913294797688,
                               0.0685479768786127
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               0.289640883977901,
                               0.126038674033149,
                               0.0947044198895028,
                               0.0688977900552486
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               0.278405255878285,
                               0.12043153526971,
                               0.0909211618257261,
                               0.0670525587828492
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               0.231728096676737,
                               0.0954702920443102,
                               0.0753454179254783,
                               0.0609123867069486
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               0.239188284518828,
                               0.0991370292887029,
                               0.0782792887029289,
                               0.0617719665271967
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               0.287599277978339,
                               0.125654632972323,
                               0.0934632972322503,
                               0.0684813477737665
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               0.24277366702938,
                               0.101653971708379,
                               0.0791860718171926,
                               0.0619336235038085
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               0.226423121387283,
                               0.0934173410404624,
                               0.0734589595375722,
                               0.0595468208092486
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               0.256150699677072,
                               0.109926803013994,
                               0.0829881593110872,
                               0.0632357373519914
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               0.234924690181125,
                               0.0986787416587226,
                               0.0759351763584366,
                               0.0603107721639657
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               0.249718396711202,
                               0.10702569373073,
                               0.0803021582733813,
                               0.0623905447070915
                            ],
                            "results":[
                               0,
                               0,
                               0,
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"water_flow",
                      "group_name":"\u6d41\u91cf",
                      "result":1,
                      "items":[
                         "permeated_water_flow",
                         "concentrated_water_flow"
                      ],
                      "item_names":[
                         "\u900f\u904e\u6c34\u6d41\u91cf",
                         "\u6fc3\u7e2e\u6c34\u6d41\u91cf"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               39.9734356552538,
                               2.99456906729634
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               41.8484813084112,
                               2.99661214953271
                            ],
                            "results":[
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               45.6421965317919,
                               2.99491329479769
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               48.0926868044515,
                               2.99538950715421
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               49.8781746031746,
                               2.99246031746032
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               49.8974566473988,
                               2.9950289017341
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               49.9120165745856,
                               2.99502762430939
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               47.9297372060857,
                               2.99654218533887
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               39.9567975830816,
                               2.99295065458207
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               41.3189330543933,
                               2.99403765690377
                            ],
                            "results":[
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               49.9004813477738,
                               2.99506618531889
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               42.4650707290533,
                               2.99466811751904
                            ],
                            "results":[
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               39.964161849711,
                               2.99560693641618
                            ],
                            "results":[
                               2,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               45.5514531754575,
                               2.99720129171152
                            ],
                            "results":[
                               0,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               42.2447092469018,
                               2.99694947569113
                            ],
                            "results":[
                               1,
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               44.9016443987667,
                               2.99660842754368
                            ],
                            "results":[
                               1,
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"conductivity",
                      "group_name":"\u5c0e\u96fb\u7387",
                      "result":2,
                      "items":[
                         "conductivity"
                      ],
                      "item_names":[
                         "\u5c0e\u96fb\u7387"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               3.07473435655254
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               3.02093457943925
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               2.98164161849711
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               2.85089030206677
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               3.05390873015873
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               3.09147976878613
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               2.98424033149171
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               3.05247579529737
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               2.99138972809668
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               3.05783472803347
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               3.10565583634176
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               3.34073993471164
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               3.43472832369942
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               3.34797631862217
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               3.44145853193518
                            ],
                            "results":[
                               2
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               3.36487153134635
                            ],
                            "results":[
                               2
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"water_temperature",
                      "group_name":"\u6c34\u6e29",
                      "result":0,
                      "items":[
                         "water_temperature"
                      ],
                      "item_names":[
                         "\u6c34\u6e29"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               8.17969303423849
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               8.02757009345794
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               8.21942196531792
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               8.25627980922099
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               8.50277777777778
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               8.58150289017341
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               8.61906077348066
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               8.47939142461964
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               8.34692849949647
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               8.42374476987448
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               8.93610108303249
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               9.06550598476605
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               9.27965317919075
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               9.86469321851453
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               10.2950428979981
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               10.4854059609455
                            ],
                            "results":[
                               0
                            ]
                         }
                      ]
                   },
                   {
                      "group_code":"corrected_permeated_water_flow",
                      "group_name":"\u88dc\u6b63\u900f\u904e\u6c34\u91cf",
                      "result":0,
                      "items":[
                         "corrected_permeated_water_flow"
                      ],
                      "item_names":[
                         "\u88dc\u6b63\u900f\u904e\u6c34\u91cf\uff08FLUX\uff09"
                      ],
                      "details":[
                         {
                            "date":"2022-03-01",
                            "values":[
                               8.17969303423849
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-02",
                            "values":[
                               8.02757009345794
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-03",
                            "values":[
                               8.21942196531792
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-04",
                            "values":[
                               8.25627980922099
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-05",
                            "values":[
                               8.50277777777778
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-06",
                            "values":[
                               8.58150289017341
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-07",
                            "values":[
                               8.61906077348066
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-08",
                            "values":[
                               8.47939142461964
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-09",
                            "values":[
                               8.34692849949647
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-10",
                            "values":[
                               8.42374476987448
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-11",
                            "values":[
                               8.93610108303249
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-12",
                            "values":[
                               9.06550598476605
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-13",
                            "values":[
                               9.27965317919075
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-14",
                            "values":[
                               9.86469321851453
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-15",
                            "values":[
                               10.2950428979981
                            ],
                            "results":[
                               0
                            ]
                         },
                         {
                            "date":"2022-03-16",
                            "values":[
                               10.4854059609455
                            ],
                            "results":[
                               0
                            ]
                         }
                      ]
                   }
                ]
             }
          ]
       }
      ),
    )
  })
]
